import { render } from "./rating-list.vue?vue&type=template&id=b99a9210&scoped=true"
import script from "./rating-list.vue?vue&type=script&lang=js"
export * from "./rating-list.vue?vue&type=script&lang=js"

import "./rating-list.vue?vue&type=style&index=0&id=b99a9210&scoped=true&lang=scss"

import exportComponent from "/tmp/build_ed238492/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b99a9210"]])

export default __exports__